module.exports = __webpack_public_path__ + "assets/img/event3.d7de2a7b.png";